export const GET_INDIVIDUAL_APPLICATION_SUCCESS = 'GET_INDIVIDUAL_APPLICATION_SUCCESS';
export const GET_INDIVIDUAL_APPLICATION = 'GET_INDIVIDUAL_APPLICATION';

export const GET_JOINT_HOLDER_SUCCESS = 'GET_JOINT_HOLDER_SUCCESS';
export const GET_JOINT_HOLDER = 'GET_JOINT_HOLDER';

export const GET_NOMINEE_LIST_SUCCESS = 'GET_NOMINEE_LIST_SUCCESS';
export const GET_NOMINEE_LIST = 'GET_NOMINEE_LIST';

export const SAVE_APPLICATION_SUCCESS = 'SAVE_APPLICATION_SUCCESS';
export const SAVE_APPLICATION = 'SAVE_APPLICATION';

export interface SaveApplicationRequestBody {
  firstName?: string;
  lastName?: string;
  namePrefix?: string;
  dob: string;
  pan?: string;
  email: string;
  gender: string;
  placeOfBirth: string;
  countryOfBirth: string;
  grossAnnualIncome: string;
  politicallyExposedPersonStatus: string;
  mobile: string;
  emailPersonRelation: string;
  phonePersonRelation: string;
  countryCode: string;
  countryNameAndCode: string;
  panVerificationToken: string;
  primaryHolderId: string | number;
  secondHolderId: string | number;
  thirdHolderId: string | number;
  kycMethod: string;
  holderNo: number;
  applicationId?: string | number;
  taxResidentOfAnyCountryOtherThanIndia?: boolean;
  taxCountryName?: string;
  taxID?: string;
  idType?: string;
}

export interface SaveApplicationResponseBody {
  [key: string]: any;
}